import script from "./PerformanceButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceButton.vue?vue&type=script&setup=true&lang=ts"

import "./PerformanceButton.vue?vue&type=style&index=0&id=247691e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247691e2"]])

export default __exports__